module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione3 b.6c4411d8.svg";